import type { StateCreator } from 'zustand'

import type { Gateway } from '../gateways.interface'

import type { GatewaysActionsSlice, GatewaysFetchPatch, GatewaysStore } from './gateways.type'

type GatewaysSet = Parameters<StateCreator<GatewaysStore, [['zustand/immer', never]], [], GatewaysStore>>[0]

export const createGatewaysSyncActions = (set: GatewaysSet): GatewaysActionsSlice => ({
  setState: (patch: GatewaysFetchPatch) => set((state) => ({ ...state, ...patch })),
  setGateways: (gateways: Gateway[]) =>
    set((state) => {
      state.gateways = gateways
    }),
  setLoading: (loading: boolean) =>
    set((state) => {
      state.loading = loading
    }),
  setError: (error: string | null) =>
    set((state) => {
      state.error = error
    }),
  setLastFetchedProjectId: (projectId: string | null) =>
    set((state) => {
      state.lastFetchedProjectId = projectId
    }),
})
